import { useCallback, useState, useEffect } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useAuth, API } from "../App";
import AdminLayout from "../components/AdminLayout";
import ProgramWizard from "../components/ProgramWizard";
import axios from "axios";
import { trackAdminWorkflowCompleted } from "../utils/adminPortalRollout";

const CreateProgramPage = ({ embedded = false, programType: programTypeOverride, routeBase = "/admin/programs" }) => {
  const { programType: routeProgramType } = useParams();
  const programType = programTypeOverride || routeProgramType;
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const [organizations, setOrganizations] = useState([]);
  const [organizationsError, setOrganizationsError] = useState("");
  const [organizationsLoading, setOrganizationsLoading] = useState(false);

  const fetchOrgs = useCallback(async () => {
    if (!token) return;
    try {
      setOrganizationsLoading(true);
      setOrganizationsError("");
      const res = await axios.get(`${API}/organizations`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setOrganizations(res.data || []);
    } catch (err) {
      console.error("Failed to fetch organizations:", err);
      setOrganizationsError("Organizations could not be loaded. Retry before creating a program.");
    } finally {
      setOrganizationsLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchOrgs();
  }, [fetchOrgs]);

  const handleSuccess = (programId) => {
    trackAdminWorkflowCompleted("program_create");
    if (programId) {
      navigate(`${routeBase}/${programId}`);
    } else {
      navigate(routeBase);
    }
  };

  if (!["recreational", "competitive", "camp", "league"].includes(programType)) {
    return <Navigate to={`${routeBase}/new`} replace />;
  }

  const content = (
      <ProgramWizard
        mode="page"
        organizations={organizations}
        defaultProgramType={programType}
        organizationsError={organizationsError}
        organizationsLoading={organizationsLoading}
        onRetryOrganizations={fetchOrgs}
        onSuccess={handleSuccess}
        // modal props not used in page mode
        open={false}
        onOpenChange={() => {}}
      />
  );
  return embedded ? content : <AdminLayout>{content}</AdminLayout>;
};

export default CreateProgramPage;
